interface AddressDisplayProps {
  addressLine?: string;
  postalCode?: string;
  city?: string;
  country?: string;
}

export const AddressDisplay = ({
  addressLine,
  postalCode,
  city,
  country,
}: AddressDisplayProps) => {
  const parts = [
    `${addressLine},`,
    postalCode && city ? `${postalCode} ${city},` : `${postalCode || city},`,
    country,
  ].filter(Boolean);

  return (
    <>
      {parts.map((part, index) => (
        <span key={index}>
          {part}
          {index < parts.length - 1 && <br />}
        </span>
      ))}
    </>
  );
};
